import API from "../../../../../services/api";
import { headers } from "../helpers/functionalities";

export const SOLICITUDES_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/solicitudes?page=${page}${search || ''}`).then(res => res.data);
    },
    new: async (solicitud) => {
        return API.post('/solicitudes', solicitud, headers).then(res => res.data);
    },
    regenerate: async (solicitudId, type) => {
        return API.post(`/solicitudes/${solicitudId}/${type}`, {}).then(res => res.data);
    },
    downloadFichaTecnica: async (solicitudId) => {
        return API.post(`/solicitudes/${solicitudId}/ficha`, null, {responseType: 'blob'}).then(res => res.data);
    }
}